import { render, staticRenderFns } from "./appFileDropper.vue?vue&type=template&id=70e11ec4&scoped=true"
import script from "./appFileDropper.vue?vue&type=script&lang=js"
export * from "./appFileDropper.vue?vue&type=script&lang=js"
import style0 from "./appFileDropper.vue?vue&type=style&index=0&id=70e11ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e11ec4",
  null
  
)

export default component.exports